import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {GuardMoney} from "@/modules/redactor/models/guard/GuardMoney";

export class FlashAdConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(FlashAdConfig, v) : SKIP;
        }, (v) => {
            return deserialize(FlashAdConfig, v);
        });
    }

    constructor() {
        super();
        this._key = null;
        this._group = 0;
        this._priority = 0;

        this._guard = null;
        this._guardMoney = null;

        this._reward = null;

        this._adPlacement = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get guardMoney() {
        return this._guardMoney;
    }

    set guardMoney(value) {
        this._guardMoney = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get adPlacement() {
        return this._adPlacement;
    }

    set adPlacement(value) {
        this._adPlacement = value;
    }

    valid() {
        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!Number.isInteger(this.group) || this.group < 0) {
            return false;
        }

        if (!Number.isInteger(this.priority) || this.priority < 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.guardMoney && !this.guardMoney.valid()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (!this.adPlacement || !RedactorUtils.getAdPlacement(this.adPlacement)) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.key || this.key.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FlashAdConfig());
        } else if (target instanceof FlashAdConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FlashAdConfig, {
    _key: alias("key", Schema.primitive()),
    _group: alias("group", Schema.primitive()),
    _priority: alias("priority", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _guardMoney: alias("guard_money", GuardMoney.schema()),

    _reward: alias("reward", RewardModel.schema()),
    _adPlacement: alias("ad_placement", Schema.primitive()),
});